import {
  AllBaseLineItemResponse,
  HandleType,
  RepairTreeItem,
  ScanLevelType
} from '@/views/dashboard/safe-status/base-line/repair-item-tree-type'

export class BaselineItemTreeOperationService {
  /**
   * @name getAllBaseLineItemId 获取所有扫描修复项目的ID
   * @param category 修复项目集合
   */
  getAllBaseLineItemId (category: RepairTreeItem[]) : any {
    return category.map((item:RepairTreeItem) => {
      if (item.items) {
        return this.getAllBaseLineItemId(item.items)
      }
      return item.id
      // eslint-disable-next-line no-magic-numbers
    }).flat(2)
  }

  /**
   * @name getAutoItemsId 获取所有自动修复项的ID
   * @param category 扫描项集合
   */
  getAutoItemsId (category: RepairTreeItem[]) : string[] {
    return category.map((item:RepairTreeItem) => {
      if (item.scan_level !== undefined) {
        return item.handle_type === HandleType.AUTO ? item.id : null
      }
      return this.getAutoItemsId(item.items)
      // eslint-disable-next-line no-magic-numbers
    }).filter(item => !!item).flat(2)
  }

  /**
   * @name getNotifyItemsId 获取所有仅通知项的ID
   * @param category 扫描项集合
   */
  getNotifyItemsId (category: RepairTreeItem[]) : string[] {
    return category.map((item:RepairTreeItem) => {
      if (item.scan_level !== undefined) {
        return item.handle_type === HandleType.NOTIFY ? item.id : null
      }
      return this.getNotifyItemsId(item.items)
      // eslint-disable-next-line no-magic-numbers
    }).filter(item => !!item).flat(2)
  }

  /**
   * @name getIgnoreItemsId 获取所有不处理修复项的ID
   * @param category 扫描项集合
   */
  getIgnoreItemsId (category: RepairTreeItem[]) : string[] {
    return category.map((item:RepairTreeItem) => {
      if (item.scan_level !== undefined) {
        return item.handle_type === HandleType.IGNORE ? item.id : null
      }
      return this.getIgnoreItemsId(item.items)
      // eslint-disable-next-line no-magic-numbers
    }).filter(item => !!item).flat(2)
  }

  /**
   * @name getNormalItemsId 获取所有常规扫描项的ID
   * @param category 扫描项集合
   */
  getNormalItemsId (category: RepairTreeItem[]) : any {
    return category.map((item:RepairTreeItem) => {
      if (item.scan_level !== undefined) {
        return item.scan_level === ScanLevelType.NORMAL ? item.id : null
      }
      return this.getNormalItemsId(item.items)
      // eslint-disable-next-line no-magic-numbers
    }).filter(item => !!item).flat(2)
  }

  /**
   * @name generateOriginalTreeWithIds 根据给定的ID生成用于展示的扫描项目树
   * @param category 扫描项集合
   * @param ids 过滤ID集合
   * @param fatherName 父节点名称
   */
  generateOriginalTreeWithIds (category: RepairTreeItem[], ids: string[], fatherName = ''): RepairTreeItem[] {
    return category.map((item:RepairTreeItem) => {
      if (item.handle_type) {
        item.fatherName = fatherName
        return ids.includes(item.id) ? item : null
      }
      item.items = this.generateOriginalTreeWithIds(item.items, ids, item.name).filter(item => !!item)
      return item.items.length ? item : null
    }).filter(item => !!item)
  }

  /**
   * @name generateInitTreeWithFatherName 生成展示要求的树（合并二级节点名字到叶子节点）
   * @param category 扫描项集合
   * @param fatherName 父节点名称
   */
  generateInitTreeWithFatherName (category: RepairTreeItem[], fatherName = '') {
    return category.map((item:RepairTreeItem) => {
      if (item.handle_type) {
        item.fatherName = fatherName
        return item
      }
      item.items = this.generateInitTreeWithFatherName(item.items, item.name)
      return item
    })
  }

  /**
   * generateTreeFactory 根据操作系统生成树
   * @param res 接口返回扫描项集合
   * @param systemTab 系统
   */
  generateTreeFactory (res: AllBaseLineItemResponse, systemTab: string) {
    if (systemTab === '1') {
      return this.generateInitTreeWithFatherName(res.category, '')
    }
    return this.generateInitTreeWithFatherName(res.linux_category, '')
  }

  /**
   * @name generateSecondTree 将三级树合并为二级树
   * @param formatTreeArray
   */
  generateSecondTree (formatTreeArray: RepairTreeItem[]) {
    return formatTreeArray.map((item: RepairTreeItem) => {
      let newItems: RepairTreeItem[] = []
      item.items.forEach((subItem: RepairTreeItem) => {
        newItems = newItems.concat(subItem.items)
      })
      item.items = newItems
      return item
    })
  }
}
